// @flow
import * as Routes from 'statsradio/helpers/constant/Routes';
import Radio from 'common/domain/radio';
import type { Permission } from './Permissions';
import Permissions from './Permissions';

const getDefaultRouteForPermission = (permission: Permission, radio: Radio): string => {
  switch (permission) {
    case Permissions.ACCESS_DASHBOARD:
      return Routes.DASHBOARD;
    case Permissions.ACCESS_DEMOGRAPHY:
      return '/demography';
    case Permissions.ACCESS_CAMPAIGNS:
    case Permissions.MANAGE_CAMPAIGNS:
    case Permissions.MANAGE_CAMPAIGNS_ADVERTISEMENT:
      return Routes.CAMPAIGNS;
    case Permissions.ACCESS_LISTENING_TIME:
      return '/listening-time';
    case Permissions.ACCESS_REACH:
      return '/reach';
    case Permissions.ACCESS_SALES:
      return radio.hasFeaturePermission('FOLLO_MODULE') ? '/sales-dashboard' : '/sales-flyer';
    case Permissions.ACCESS_SPOTS:
      return '/spots';
    case Permissions.ACCESS_HISTORY:
      return '/history';
    case Permissions.MANAGE_USERS:
      return '/user-management';
    case Permissions.MANAGE_CUSTOMERS:
      return '/customers';
    case Permissions.MANAGE_ALL_CUSTOMERS:
      return '/all-customers';
    case Permissions.ACCESS_CONFIGURATION:
      return '/configure-radio';
    case Permissions.ACCESS_QUALITATIVE:
      return '/survey';
    case Permissions.BILL_RADIOS:
      return Routes.INVOICING;
    case Permissions.ACCESS_STREAMING:
      return '/streaming';
    default:
      return '/no-permissions';
  }
};

export default getDefaultRouteForPermission;



// WEBPACK FOOTER //
// ./src/statsradio/modules/authorisation/PermissionDefaultRoutes.js